export default __webpack_public_path__ + "static/media/atoj-logo.2df3a7bc.png";